// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallRate {
    display: grid;
    align-items: center;
    justify-content: start;
    grid-template-columns: auto auto auto;
    gap: 8px;
    padding: 10px 0 14px;
}

.SmallRate-stars {
    display: grid;
    align-items: center;
    grid-template-columns: 16px 16px 16px 16px 16px;
    gap: 4px;
    font-size: var(--font-paragraph);
}

.SmallRate-stars li {
    color: var(--rateStarsColorDisable);
}

.SmallRate-stars li.SmallRate-stars-active {
    color: var(--rateStarsColor);
}

.SmallRate-rate {
    font-weight: 600;
    color: var(--color-neutral-dark);
    font-size: var(--font-small);
    font-family: var(--font-family);
    padding-left: var(--spacing-extra-small);
}
.SmallRate-total {
    font-size: var(--font-small);
    color: var(--color-neutral-dark);
    font-weight: 500;
    font-family: var(--font-family);
    padding-left: var(--spacing-extra-small);
}

.vert-card-store-rate, .vert-card-product-rate {
    margin-bottom: calc(var(--spacing-extra-small) /2);
}

.vert-card-store-rate-average {
    font-weight: 600;
    color: var(--color-neutral-dark);
    font-size: var(--font-small);
    font-family: var(--font-family);
    padding-left: var(--spacing-extra-small);
}
.vert-card-store-rate-total {
    font-size: var(--font-small);
    color: var(--color-neutral-dark);
    font-weight: 500;
    font-family: var(--font-family);
    padding-left: var(--spacing-extra-small);
}

.vert-card-product-rate {
    margin-bottom: calc(var(--spacing-extra-small) /2);
}`, "",{"version":3,"sources":["webpack://./src/Shared/common/components/SmallRate/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,qCAAqC;IACrC,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,wCAAwC;AAC5C;AACA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,wCAAwC;AAC5C;AACA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":[".SmallRate {\n    display: grid;\n    align-items: center;\n    justify-content: start;\n    grid-template-columns: auto auto auto;\n    gap: 8px;\n    padding: 10px 0 14px;\n}\n\n.SmallRate-stars {\n    display: grid;\n    align-items: center;\n    grid-template-columns: 16px 16px 16px 16px 16px;\n    gap: 4px;\n    font-size: var(--font-paragraph);\n}\n\n.SmallRate-stars li {\n    color: var(--rateStarsColorDisable);\n}\n\n.SmallRate-stars li.SmallRate-stars-active {\n    color: var(--rateStarsColor);\n}\n\n.SmallRate-rate {\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n    font-size: var(--font-small);\n    font-family: var(--font-family);\n    padding-left: var(--spacing-extra-small);\n}\n.SmallRate-total {\n    font-size: var(--font-small);\n    color: var(--color-neutral-dark);\n    font-weight: 500;\n    font-family: var(--font-family);\n    padding-left: var(--spacing-extra-small);\n}\n\n.vert-card-store-rate, .vert-card-product-rate {\n    margin-bottom: calc(var(--spacing-extra-small) /2);\n}\n\n.vert-card-store-rate-average {\n    font-weight: 600;\n    color: var(--color-neutral-dark);\n    font-size: var(--font-small);\n    font-family: var(--font-family);\n    padding-left: var(--spacing-extra-small);\n}\n.vert-card-store-rate-total {\n    font-size: var(--font-small);\n    color: var(--color-neutral-dark);\n    font-weight: 500;\n    font-family: var(--font-family);\n    padding-left: var(--spacing-extra-small);\n}\n\n.vert-card-product-rate {\n    margin-bottom: calc(var(--spacing-extra-small) /2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
